var render = function () {
  var _vm$item, _vm$item$company, _vm$item2, _vm$item2$recruitment, _vm$item3, _vm$item3$recruitment, _vm$item4, _vm$item4$recruitment, _vm$item4$recruitment2, _vm$item4$recruitment3, _vm$item4$recruitment4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._g({
    attrs: {
      "outlined": "",
      "rounded": "lg"
    }
  }, _vm.cardEventHandler), [_c('div', {
    staticClass: "pa-20"
  }, [_c('v-row', {
    staticClass: "row--large",
    attrs: {
      "align": "center"
    }
  }, [_vm.mode == 'form' ? _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-simple-checkbox', {
    attrs: {
      "value": _vm.isSelected,
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.toggle(_vm.item);
      }
    }
  })], 1) : _vm._e(), _c('v-col', {
    staticClass: "micepec-item__detail mb-10 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": ""
    }
  }, [_c('v-layout', {
    staticClass: "w-100 h-100",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('p', {
    staticClass: "page-text--sm primary--text"
  }, [_vm._v(" " + _vm._s((_vm$item = _vm.item) === null || _vm$item === void 0 ? void 0 : (_vm$item$company = _vm$item.company) === null || _vm$item$company === void 0 ? void 0 : _vm$item$company.name) + " ")]), _c('h5', {
    staticClass: "page-text--lg font-weight-medium mb-8 mb-lg-16"
  }, [_c('a', {
    attrs: {
      "href": "/recruitments/".concat((_vm$item2 = _vm.item) === null || _vm$item2 === void 0 ? void 0 : (_vm$item2$recruitment = _vm$item2.recruitment) === null || _vm$item2$recruitment === void 0 ? void 0 : _vm$item2$recruitment._id),
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(" " + _vm._s((_vm$item3 = _vm.item) === null || _vm$item3 === void 0 ? void 0 : (_vm$item3$recruitment = _vm$item3.recruitment) === null || _vm$item3$recruitment === void 0 ? void 0 : _vm$item3$recruitment.subject) + " ")])]), _c('v-chip-group', _vm._l((_vm$item4 = _vm.item) === null || _vm$item4 === void 0 ? void 0 : (_vm$item4$recruitment = _vm$item4.recruitment) === null || _vm$item4$recruitment === void 0 ? void 0 : (_vm$item4$recruitment2 = _vm$item4$recruitment.employment) === null || _vm$item4$recruitment2 === void 0 ? void 0 : (_vm$item4$recruitment3 = _vm$item4$recruitment2.typesTexts) === null || _vm$item4$recruitment3 === void 0 ? void 0 : (_vm$item4$recruitment4 = _vm$item4$recruitment3.filter) === null || _vm$item4$recruitment4 === void 0 ? void 0 : _vm$item4$recruitment4.call(_vm$item4$recruitment3, function (item) {
    return item;
  }), function (text) {
    return _c('v-chip', {
      key: text,
      attrs: {
        "small": "",
        "outlined": "",
        "color": "grey-d"
      }
    }, [_c('span', {
      staticClass: "grey-6--text"
    }, [_vm._v(_vm._s(text))])]);
  }), 1)], 1)], 1), _c('v-col', {
    staticClass: "d-none d-lg-block",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-layout', {
    staticClass: "h-100",
    attrs: {
      "align-center": ""
    }
  }, [_c('span', {
    staticClass: "line"
  })])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-layout', {
    staticClass: "text-lg-center w-100 h-100 duration-wrap",
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('micepec-record-item-duration', _vm._b({}, 'micepec-record-item-duration', _vm.item.recruitment, false))], 1)], 1), _c('v-col', {
    staticClass: "d-none d-lg-block",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-layout', {
    staticClass: "h-100",
    attrs: {
      "align-center": ""
    }
  }, [_c('span', {
    staticClass: "line"
  })])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-layout', {
    staticClass: "w-100 h-100 pr-lg-20",
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('micepec-record-certification', {
    attrs: {
      "value": _vm.item
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var _vm$item5;
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "x-large": "",
            "color": "grey-f7"
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          class: "".concat((_vm$item5 = _vm.item) !== null && _vm$item5 !== void 0 && _vm$item5.isCertified ? 'icon icon-cert-on' : 'icon icon-cert-off')
        })])];
      }
    }])
  }), _vm.mode == 'form' ? _c('v-overlay', {
    attrs: {
      "absolute": "",
      "color": "transparent"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }